import {
	EditHistoryRequest,
} from "../types/requests";
import { API_URL } from "../utils";

export default async (
	variables: EditHistoryRequest
): Promise<boolean> => {
	const headers = new Headers();

	headers.append("Content-Type", "application/json;charset=utf-8");

	const request = await fetch(`${API_URL}/cards/history/edit`, {
		headers,
		method: "POST",
		body: JSON.stringify(variables),
		credentials: "include",
	});

	const jsonRequest = await request.json();

	return jsonRequest;
};
